<br />
<div class="container">
  <div class="row">
    <div class="col-sm-12">
      <app-system-wide-message></app-system-wide-message>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-6">

      <!-- <span class="badge" *ngIf="schedule[0].route_type != 1">Block</span>
      <span class="badge" *ngIf="schedule[0].route_type == 1">Trip</span>
      <h2 *ngIf="schedule[0].route_type != 1">{{ schedule[0].block_id }}</h2>
      <h2 *ngIf="schedule[0].route_type == 1">{{ schedule[0].trip_id }}</h2> -->

      <span class="badge">Block</span>
      <h2>{{ schedule[0].block_id }}</h2>

      <p> {{ trip_headsign }} </p>

      <ng-container *ngFor="let route of routes">
        <ng-container *ngIf="route.id == route_id">
          <p>
            <a class="btn btn-outline-secondary" routerLink="/routes/status/{{route.id}}">
              <div class="route-selection-status" style="cursor: pointer;">
                <span [ngClass]="{'icon-inactive': route.isalert === false}">
                  <img class="status-icons" src="../../../assets/images/route-status/alert.png"
                    *ngIf="route.issuspended == false">
                  <img class="status-icons" src="../../../assets/images/route-status/suspended.png"
                    *ngIf="route.issuspended == true">
                </span>
                <span [ngClass]="{'icon-inactive': route.isadvisory === false}">
                  <img class="status-icons" alt="Advisories status icon"
                    src="../../../assets/images/route-status/advisory.png">
                </span>
                <span [ngClass]="{'icon-inactive': route.isdetour === false}" *ngIf="route.isweather == true">
                  <img class="status-icons" alt="Detour weather status icon"
                    src="../../../assets/images/route-status/weather-icon.png">
                </span>
                <span [ngClass]="{'icon-inactive': route.isdetour === false}" *ngIf="route.isweather == false">
                  <img class="status-icons" alt="Detour status icon"
                    src="../../../assets/images/route-status/detour.png">
                </span>
                <span [ngClass]="{'icon-inactive': route.iselevator === false}">
                  <img class="status-icons" alt="Elevator status icon"
                    src="../../../assets/images/route-status/elevator.gif">
                </span>
              </div>
            </a>
          </p>
        </ng-container>
      </ng-container>

      <div class="row d-flex p-2 text-center">
        <nav>
          <div class="nav nav-tabs" id="nav-tab" role="tablist">
            <a class="nav-item nav-link active" id="nav-details-tab" data-toggle="tab" href="#nav-details" role="tab"
              aria-controls="nav-details" aria-selected="true">
              <span class="badge">
                Details
              </span>
            </a>
            <a class="nav-item nav-link" id="nav-arrivals-tab" data-toggle="tab" href="#nav-arrivals" role="tab"
              aria-controls="nav-arrivals" aria-selected="false">
              <span class="badge">
                Schedule
              </span>
            </a>

          </div>
        </nav>
      </div>

      <div class="tab-content" id="nav-tabContent">
        <br />
        <div class="tab-pane fade show active" id="nav-details" role="tabpanel" aria-labelledby="nav-details-tab">
          <div class="alert text-center" role="alert"
            [ngClass]="{'alert-dark': late == null, 'alert-success': late <= 0, 'alert-warning': late > 0 && late < 999, 'alert-danger': late == 999}">
            {{ status}}
          </div>
          <p> Route: <strong> {{ route_name }} </strong></p>
          <p> Destination: <strong> {{ trip_headsign }}</strong></p>
          <p> Start Time: <strong> {{ start_time }}</strong></p>
          <p> End Time: <strong> {{ end_time }}</strong></p>
          <p *ngIf="next_stop_name != null"> Next Stop: <strong> {{ next_stop_name }}</strong></p>
          <p *ngIf="cars != null"> Cars: <strong> {{ car_count }} -</strong> {{ cars }}</p>
          <p *ngIf="vehicle != null"> Vehicle: <strong> {{ vehicle }} </strong></p>
          <p *ngIf="type != null"> Type: <strong> {{ type }} </strong></p>
          <p *ngIf="estimated_seat_availability != null"> Estimated Seats: <strong>
              {{ estimated_seat_availability_html }} </strong></p>
        </div>
        <div class="tab-pane fade show" id="nav-arrivals" role="tabpanel" aria-labelledby="nav-arrivals-tab">
          <table class="table table-bordered" *ngIf="schedule">
            <thead>
              <tr>
                <th scope="col">Stop</th>
                <th scope="col">Scheduled</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let times of schedule"
                [ngClass]="{'alert-dark': next_stop_sequence > times.stop_sequence && next_stop_sequence != null}">
                <td>
                  <div>
                    {{ times.stop_name }}
                  </div>
                  <div>
                    <span class="badge badge-secondary" *ngIf="next_stop_sequence > times.stop_sequence">Departed</span>
                    <span class="badge" [ngClass]="{'badge-dark': late == null, 'badge-success': late <= 0, 'badge-warning': late > 0 && late < 999, 'badge-danger': late == 999}" *ngIf="next_stop_sequence <= times.stop_sequence">{{ status }}</span>
                  </div>
                </td>
                <td> 
                  <div class="stop-schedule-time" [ngClass]="{'text-decoration-line-through' : late > 0 && next_stop_sequence <= times.stop_sequence && late < 900}">
                    {{ times.arrival_time }} 
                  </div>
                  <div class="stop-actual-eta text-danger" *ngIf="next_stop_sequence <= times.stop_sequence && late > 0 && late < 900">
                    {{ (times.actual_arrival_time + ( late * 60000)) | date:'hh:mm a' | lowercase }} 
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="col-lg-6">
      <div>
        <span class="badge">Map</span>
        <div class="card mt-2">
          <div>
            <app-embedded-map-trip></app-embedded-map-trip>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-main-footer></app-main-footer>
